import { object, string, ref } from 'yup-updated';

const schema = object().shape({
  routingNumber: string()
    .required('Routing Number is required')
    .matches(/^\d{9}$/, {
      message: 'Routing Number should be 9 digits'
    })
    .max(9, 'Routing Number should be 9 digits')
    .min(9, 'Routing Number should be 9 digits')
    .test('valid-aba-routing', 'Invalid Routing Number', value => {
      if (value && value.length > 0) {
        let total = 0;
        for (let i = 0; i < value.length; i += 3) {
          total +=
            parseInt(value.charAt(i), 10) * 3 +
            parseInt(value.charAt(i + 1), 10) * 7 +
            parseInt(value.charAt(i + 2), 10);
        }
        return total !== 0 && total % 10 === 0;
      }
      return false;
    }),
  accountNumber: string()
    .required('Account Number is required')
    .matches(/^\d{4,17}$/, {
      message: 'Account Number should be 4-17 digits (numbers only)'
    })
    .max(17, 'Account Number cannot be greater than 17 digits')
    .min(4, ' Account Number cannot be less than 4 digits'),
  accountNumberConfirm: string()
    .required('Confirm Account Number')
    .oneOf([ref('accountNumber'), null], `This entry doesn't match the entry above`)
});

export default schema;
